import axios from 'axios'

import { RecurringProfileInterface, RecurringProfileStatusEventType } from '../Interfaces/RecurringProfileInterface'
import { getRequestConfig } from './index'

export async function getRecurringProfiles(): Promise<RecurringProfileInterface[]> {
  const url = '/rest-invoice/api/recurring-profile'
  const response = await axios.get(url, getRequestConfig())
  return Promise.resolve(response.data)
}

export async function getRecurringProfile(id: number): Promise<RecurringProfileInterface> {
  const url = `/rest-invoice/api/recurring-profile/${id}`
  const response = await axios.get(url, getRequestConfig())
  return Promise.resolve(response.data)
}

export async function createRecurringProfile(data: RecurringProfileInterface): Promise<RecurringProfileInterface> {
  const url = '/rest-invoice/api/recurring-profile'
  const response = await axios.post(url, data, getRequestConfig())
  return Promise.resolve(response.data)
}

export async function updateRecurringProfile(data: RecurringProfileInterface): Promise<RecurringProfileInterface> {
  const url = `/rest-invoice/api/recurring-profile/${data.id}`
  const response = await axios.put(url, data, getRequestConfig())
  return Promise.resolve(response.data)
}

export async function deleteRecurringProfile(id: number): Promise<number> {
  const url = `/rest-invoice/api/recurring-profile/${id}`
  const response = await axios.delete(url, getRequestConfig())
  return Promise.resolve(response.data)
}

export async function setRecurringProfileStatus(
  id: number,
  status: RecurringProfileStatusEventType,
): Promise<RecurringProfileInterface> {
  const url = `/rest-invoice/api/recurring-profile/${id}/event/${status}`
  const response = await axios.post(url, null, getRequestConfig())
  return Promise.resolve(response.data)
}
